import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface InteractiveElementOverlayFooterProps {
  onClose: () => void;
  /** When false, renders nothing (e.g. still answering — header close only). */
  visible?: boolean;
  /** CTA wording; "Abschließen" where the element is handed in, not just read. */
  label?: string;
  /**
   * Top separator. Code quizzes already draw one on the action row, so the
   * close bar skips its own.
   */
  bordered?: boolean;
}

/**
 * Overlay footer with a centered CTA — used when reviewing a completed element.
 */
const InteractiveElementOverlayFooter = ({
  onClose,
  visible = true,
  label = "Fertig",
  bordered = true,
}: InteractiveElementOverlayFooterProps) => {
  if (!visible) return null;

  return (
    <footer
      className={cn(
        "flex justify-center px-6 py-4",
        bordered && "border-t border-[#e3e9f2]"
      )}
    >
      <Button size="xl" onClick={onClose}>
        {label}
      </Button>
    </footer>
  );
};

export default InteractiveElementOverlayFooter;
